import React from 'react';
import PropTypes from 'prop-types';
import {Menu} from './Menu';
import {Wrapper} from './Wrapper';

export function MenuList(props) {
  const onSelect = (sectionValue) => () => props.onSelect(sectionValue);

  const getClassName = ({current}) =>
    current ? props.activeMenuClass : props.inactiveMenuClass;

  const renderMenu = (menu) => (
    <Menu
      {...menu}
      key={menu.value}
      className={getClassName(menu)}
      onSelect={onSelect(menu.value)}
    />
  );

  return (
    <Wrapper className={props.className}>
      {props.menuList.map(renderMenu)}
    </Wrapper>
  );
}

MenuList.propTypes = {
  /**
   * Callback fired when a Menu is Selected/Clicked
   */
  onSelect: PropTypes.func,
  /**
   * List of Menu to display
   */
  menuList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Title to display in  menu
       */
      title: PropTypes.string.isRequired,
      /**
       * Boolean specifying if menu is selected
       */
      current: PropTypes.bool.isRequired,
      /**
       * Index number of menu
       */
      number: PropTypes.number.isRequired,
      /**
       * Unique string value of the menu
       */
      value: PropTypes.string.isRequired,
      /**
       * Boolean set when section is visited
       */
      visited: PropTypes.bool.isRequired,
    })
  ),
  /**
   * ClassName to set on InactiveMenu
   */
  inactiveMenuClass: PropTypes.string,
  /**
   * ClassName to set on ActiveMenu
   */
  activeMenuClass: PropTypes.string,
};

MenuList.defaultProps = {
  inactiveMenuClass: '',
  activeMenuClass: '',
};
